import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import Modal from "react-modal";
import moment from "moment";

const MarketDetailsForm = (props) => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      //    border: "5px solid #96dc00",
    },
  };
  const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().substr(0, 10);
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [vehicleClose, setVehicleClose] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [vehicleId, setVehicleId] = useState(0);

  const [marketName, setMarketName] = useState("");

  const [staffDetails, setStaffDetails] = useState([]);
  const [teamDetails, setTeamDetails] = useState([]);

  const [staffClose, setStaffClose] = useState(false);
  const [teamClose, setTeamClose] = useState(false);

  const [staffEmpId, setStaffEmpId] = useState("");
  const [staffEmpName, setStaffEmpName] = useState("");
  const [staffEmpPhone, setStaffEmpPhone] = useState("");
  const [StaffWorkAllocation, setStaffWorkAllocation] = useState("");

  const [empType, setEmpType] = useState("");

  const [storeData, setStoreData] = useState([]);
  const [areaId, setAreaId] = useState(0);
  const [marketDate, setMarketDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const [storeId, setStoreId] = useState("");

  const { sendRequest: getAreaData } = useHttp();
  const [areaData, setAreaData] = useState([]);

  const FillDetail = () => {
    getAreaData(
      {
        url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setAreaData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getAreaData]);

  const { sendRequest: getwarehouse } = useHttp();

  useEffect(() => {
    getwarehouse(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setStoreData(res);
        }
      }
    );
  }, [getwarehouse]);

  const { sendRequest: postMarketDetails } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);

    const data = {
      areaId: areaId,
      marketDate: moment(marketDate).format("DD/MM/YYYY"),
      marketName: marketName,
      warehouseId: storeId,
      staffData: [...staffDetails, ...teamDetails],
      vehicleData: vehicleDetails,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: moment(currentDate).format("DD/MM/YYYY"),
      serviceId: props.sId,
    };

    console.log("data", data);

    if (props.update) {
      data["marketDetailId"] = props.update.marketDetailId;
    }

    postMarketDetails(
      {
        url: "/api/marketDetail/",
        method: props.update ? "PUT" : "POST",

        body: data,
      },
      (res) => {
        toast.success(`Market Details ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };

  //popup code

  const submitVehicle = (e) => {
    e.preventDefault();

    if (vehicleId) {
      const filteredVehicle =
        vehicleData && vehicleData.find((itm) => itm.vmerId == vehicleId);

      // Check if the vehicle already exists in vehicleDetails
      const vehicleExists = vehicleDetails.some(
        (detail) => detail.vehicleCode === filteredVehicle?.VehicleCode
      );

      if (!vehicleExists) {
        setVehicleDetails((x) => [
          ...x,
          {
            vehicleId: filteredVehicle?.vmerId,
            vehicleCode: filteredVehicle?.VehicleCode,
            vehicleName: filteredVehicle?.vmeNo,
            driverName: filteredVehicle?.assignedPersonDriverName,
            status: 1,
          },
        ]);
      } else {
        toast.error("Vehicle already exists in the list");
      }
    }
    setVehicleId(0);
  };

  const handleVehicleDelete = (index, e) => {
    setVehicleDetails(vehicleDetails.filter((v, i) => i !== index));
  };

  const { sendRequest: getVehicle } = useHttp();
  useEffect(() => {
    getVehicle(
      {
        url: "/api/vehicleMachineEquipRegistratn/",
      },
      (res) => {
        if (res) {
          var vehicle = res.filter((x) => x.vmeClassific == "Vehicle");

          setVehicleData(vehicle);
        }
      }
    );
  }, [getVehicle]);

  const addStaff = (e) => {
    e.preventDefault();
    if (
      staffDetails &&
      staffDetails.some((staff) => staff.employeeId === staffEmpId)
    ) {
      toast.error("Employee ID already exists in Staff details.");
      setStaffEmpId("");
      setStaffEmpName("");
      setStaffEmpPhone("");
      setStaffWorkAllocation("");
      return;
    }

    setStaffDetails((x) => [
      ...x,
      {
        empType: empType,
        employeeId: staffEmpId,
        employeeName: staffEmpName,
        phoneNo: staffEmpPhone,

        workAllocation: StaffWorkAllocation,
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
      },
    ]);

    setStaffEmpId("");
    setStaffEmpName("");
    setStaffEmpPhone("");
    setStaffWorkAllocation("");
  };

  const handleStaffDelete = (index, e) => {
    e.preventDefault();
    setStaffDetails(staffDetails.filter((v, i) => i !== index));
  };

  const addTeam = (e) => {
    e.preventDefault();
    if (
      teamDetails &&
      teamDetails.some((team) => team.employeeId === staffEmpId)
    ) {
      toast.error("Employee ID already exists in Team details.");
      setStaffEmpId("");
      setStaffEmpName("");
      setStaffEmpPhone("");
      setStaffWorkAllocation("");
      return;
    }
    setTeamDetails((x) => [
      ...x,
      {
        empType: empType,
        employeeId: staffEmpId,
        employeeName: staffEmpName,
        phoneNo: staffEmpPhone,

        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
      },
    ]);

    setStaffEmpId("");
    setStaffEmpName("");
    setStaffEmpPhone("");
    setStaffWorkAllocation("");
  };

  const handleTeamDelete = (index, e) => {
    e.preventDefault();
    setTeamDetails(teamDetails.filter((v, i) => i !== index));
  };

  const { sendRequest: getUpdateData } = useHttp();

  useEffect(() => {
    if (props.update) {
      console.log(props.update);

      setAreaId(props.update.areaId);
      setMarketName(props.update.marketName);
      setStoreId(props.update.warehouseId);
      setMarketDate(moment(props.update.marketDate).format("YYYY-MM-DD"));

      getUpdateData(
        {
          url: `/api/marketDetail/?orgId=${localStorage.getItem(
            "orgId"
          )}&marketDetailId=${props.update.marketDetailId}`,
        },
        (res) => {
          if (res) {
            // console.log(res);

            if (res.teamData) {
              const transformedData =
                res.teamData &&
                res.teamData.map((item) => ({
                  marketTeamId: item.marketTeamId,
                  marketDetailId: item.marketDetailId,
                  empType: item.empType,
                  employeeId: item.employeeId,
                  employeeName: item.employeeName,
                  phoneNo: item.phoneNo,
                  status: item.status,
                  createdBy: parseInt(localStorage.getItem("id")),
                  orgId: localStorage.getItem("orgId"),
                }));

              setTeamDetails(transformedData);

              //  console.log(transformedData);

              // setStaffDetails(res.staffData);
            }

            if (res.staffData) {
              const transformedSTData =
                res.staffData &&
                res.staffData.map((item) => ({
                  marketTeamId: item.marketTeamId,
                  marketDetailId: item.marketDetailId,
                  empType: item.empType,
                  employeeId: item.employeeId,
                  employeeName: item.employeeName,
                  phoneNo: item.phoneNo,
                  workAllocation: item.workAllocation,
                  status: item.status,
                  createdBy: parseInt(localStorage.getItem("id")),
                  orgId: localStorage.getItem("orgId"),
                }));

              setStaffDetails(transformedSTData);
            }
            //console.log(res.vehicleData);

            if (res.vehicleData) {
              const transformedVeData =
                res.vehicleData &&
                res.vehicleData.map((item) => ({
                  vehicleId: item?.vehicleId,
                  vehicleCode: item?.VehicleCode,
                  vehicleName: item?.vmeNo,
                  driverName: item?.assignedPersonDriverName,
                  marketVehicleId: item?.marketVehicleId,
                  marketDetailId: item?.marketDetailId,
                  status: 1,
                }));

              setVehicleDetails(transformedVeData);
              // console.log(transformedVeData);
            }
          }
        }
      );
    }
  }, [props.update]);

  return (
    <>
      <Modal isOpen={vehicleClose} style={customModalStyles}>
        <div className="">
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Vehicle Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setVehicleClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-4">
                {" "}
                <label htmlFor={"vehicleId"}> Vehicle Name</label>
                <select
                  id="vehicleId"
                  className="form-control"
                  value={vehicleId}
                  onChange={(e) => {
                    setVehicleId(e.target.value);
                  }}
                >
                  <option value="0">Select Vehicle</option>
                  {vehicleData &&
                    vehicleData.map((x) => (
                      <option key={x.vmerId} value={x.vmerId}>
                        {x.vmeNo}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="row mb-2">
              <br />
              <div className="col-md-3">
                {" "}
                <button
                  className="btn btn-success mx-2 my-2"
                  onClick={submitVehicle}
                >
                  +
                </button>{" "}
              </div>
            </div>

            <hr />

            <div className="">
              <table className="table table-bordered">
                <thead>
                  <tr className="tableheaderrow mb-2view">
                    <th>Sr. No</th>
                    <th>Vehicle Code</th>
                    <th>Vehicle Name</th>
                    <th>Driver Name</th>

                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {vehicleDetails &&
                    vehicleDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>

                          <td>{itm.vehicleCode}</td>
                          <td>{itm.vehicleName}</td>
                          <td>{itm.driverName}</td>

                          <td>
                            {" "}
                            <button
                              className="btn"
                              onClick={(e) => handleVehicleDelete(i, e)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row mb-2">
              <div className="col-md-3"></div>
              <div className="col-md-2"></div>

              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    vehicleDetails.map((x) => (x["isSave"] = true));
                    setVehicleClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal isOpen={staffClose} style={customModalStyles}>
        <form onSubmit={addStaff}>
          <div className="">
            <div>
              <div className="">
                <div className="">
                  <h3 className="card-title">Staff Allocation</h3>

                  <div className="card-tools text-right">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => setStaffClose(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                    <hr />
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-3">
                  {" "}
                  <label htmlFor={"employee_code"}>Employee Id </label>
                  <input
                    type={"text"}
                    id={"employee_code"}
                    className="form-control"
                    value={staffEmpId}
                    onChange={(e) => {
                      setStaffEmpId(e.target.value);
                    }}
                    required
                  />
                </div>
                <div className="col-md-3">
                  {" "}
                  <label htmlFor={"employee_name"}> Employee Name</label>
                  <input
                    type={"text"}
                    id={"employee_name"}
                    className="form-control"
                    value={staffEmpName}
                    onChange={(e) => {
                      setStaffEmpName(e.target.value);
                    }}
                    required
                  />
                </div>
                <div className="col-md-3">
                  {" "}
                  <label htmlFor={"phone"}>Phone</label>
                  <input
                    type={"phone"}
                    id={"phone"}
                    className="form-control"
                    value={staffEmpPhone}
                    onChange={(e) => {
                      setStaffEmpPhone(e.target.value);
                    }}
                    required
                  />
                </div>

                <div className="col-md-3">
                  {" "}
                  <label htmlFor={"work_allocation"}>Work Allocation</label>
                  <select
                    id="work_allocation"
                    className="form-control"
                    value={StaffWorkAllocation}
                    onChange={(e) => {
                      setStaffWorkAllocation(e.target.value);
                    }}
                    required
                  >
                    <option value="">Select</option>
                    <option value="Buyers">Buyers</option>
                    <option value="Casuals">Casuals</option>
                    <option value="Classifiers">Classifiers</option>
                    <option value="Clerks">Clerks</option>
                    <option value="Loaders">Loaders</option>
                    <option value="Watchmen">Watchmen</option>

                    
                  </select>
                </div>
              </div>

              <div className="row mb-2">
                <br />
                <div className="col-md-3">
                  {" "}
                  <button className="btn btn-success mx-2 my-2" type="submit">
                    +
                  </button>{" "}
                </div>
              </div>

              <hr />

              <div className="">
                <table className="table table-bordered">
                  <thead>
                    <tr className="tableheaderrow mb-2view">
                      <th>Sr. No</th>
                      <th>Employee Code</th>
                      <th>Employee Name</th>
                      <th>Phone</th>
                      <th>Work Allocation</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {staffDetails &&
                      staffDetails.map((itm, i) => {
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{itm.employeeId}</td>
                            <td>{itm.employeeName}</td>
                            <td>{itm.phoneNo}</td>
                            <td>{itm.workAllocation}</td>
                            <td>
                              {" "}
                              <button
                                type="button"
                                className="btn"
                                onClick={(e) => handleStaffDelete(i, e)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              <div className="row mb-2">
                <div className="col-md-3"></div>
                <div className="col-md-2"></div>

                <div className="col-md-2">
                  <button
                    className="btn  btn-primary mx-2 my-2"
                    type="button"
                    onClick={() => {
                      staffDetails.map((x) => (x["isSave"] = true));
                      setStaffClose(false);
                    }}
                  >
                    Save
                  </button>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
          </div>
        </form>
      </Modal>

      <Modal isOpen={teamClose} style={customModalStyles}>
        <form onSubmit={addTeam}>
          <div className="">
            <div>
              <div className="">
                <div className="">
                  <h3 className="card-title">Market Team Details</h3>

                  <div className="card-tools text-right">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => setTeamClose(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                    <hr />
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-3">
                  {" "}
                  <label htmlFor={"employee_code"}>Employee Id </label>
                  <input
                    type={"text"}
                    id={"employee_code"}
                    className="form-control"
                    value={staffEmpId}
                    onChange={(e) => {
                      setStaffEmpId(e.target.value);
                    }}
                    required
                  />
                </div>
                <div className="col-md-3">
                  {" "}
                  <label htmlFor={"employee_name"}> Employee Name</label>
                  <input
                    type={"text"}
                    id={"employee_name"}
                    className="form-control"
                    value={staffEmpName}
                    onChange={(e) => {
                      setStaffEmpName(e.target.value);
                    }}
                    required
                  />
                </div>
                <div className="col-md-3">
                  {" "}
                  <label htmlFor={"phone"}>Phone</label>
                  <input
                    type={"phone"}
                    id={"phone"}
                    className="form-control"
                    value={staffEmpPhone}
                    onChange={(e) => {
                      setStaffEmpPhone(e.target.value);
                    }}
                    required
                  />
                </div>
              </div>

              <div className="row mb-2">
                <br />
                <div className="col-md-3">
                  {" "}
                  <button className="btn btn-success mx-2 my-2" type="submit">
                    +
                  </button>{" "}
                </div>
              </div>

              <hr />

              <div className="">
                <table className="table table-bordered">
                  <thead>
                    <tr className="tableheaderrow mb-2view">
                      <th>Sr. No</th>
                      <th>Employee Code</th>
                      <th>Employee Name</th>
                      <th>Phone</th>

                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {teamDetails &&
                      teamDetails.map((itm, i) => {
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>

                            <td>{itm.employeeId}</td>
                            <td>{itm.employeeName}</td>
                            <td>{itm.phoneNo}</td>

                            <td>
                              {" "}
                              <button
                                type="button"
                                className="btn"
                                onClick={(e) => handleTeamDelete(i, e)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              <div className="row mb-2">
                <div className="col-md-3"></div>
                <div className="col-md-2"></div>

                <div className="col-md-2">
                  <button
                    className="btn  btn-primary mx-2 my-2"
                    type="button"
                    onClick={() => {
                      teamDetails.map((x) => (x["isSave"] = true));
                      setTeamClose(false);
                    }}
                  >
                    Save
                  </button>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
          </div>
        </form>
      </Modal>

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Market Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Market Date</label>
                        <input
                          type={"date"}
                          id={"marketDate"}
                          required
                          className="form-control"
                          value={marketDate}
                          onChange={(e) => {
                            setMarketDate(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Area Name</label>
                        <select
                          id="station name"
                          className="form-control"
                          required
                          value={areaId}
                          onChange={(e) => {
                            setAreaId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {areaData &&
                            areaData.map((x) => (
                              <option key={x.areaId} value={x.areaId}>
                                {x.areaName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Store</label>
                        <select
                          id="station name"
                          className="form-control"
                          required
                          value={storeId}
                          onChange={(e) => {
                            setStoreId(e.target.value);
                          }}
                        >
                          <option value="">Select</option>
                          {storeData &&
                            storeData.map((x) => (
                              <option key={x.id} value={x.id}>
                                {x.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Market Name</label>
                        <input
                          type={"text"}
                          id={"marketName"}
                          required
                          className="form-control"
                          value={marketName}
                          onChange={(e) => {
                            setMarketName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <br />
                      <button
                        className="btn btn-success mx-2"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault(false);
                          teamDetails &&
                            setTeamDetails((items) =>
                              items.filter(
                                (x) => x.isSave || x.marketTeamId > 0
                              )
                            );
                          setEmpType("Team");
                          setTeamClose(true);
                        }}
                      >
                        Market Team Details
                      </button>

                      <button
                        className="btn  btn-info mx-2"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault(false);
                          vehicleDetails &&
                            setVehicleDetails((items) =>
                              items.filter(
                                (x) => x.isSave || x.marketVehicleId > 0
                              )
                            );
                          setVehicleClose(true);
                        }}
                      >
                        Market Vehicle Details
                      </button>

                      <button
                        className="btn btn-success mx-2"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault(false);
                          staffDetails &&
                            setStaffDetails((items) =>
                              items.filter((x) => x.isSave || x.marketTeamId)
                            );
                          setEmpType("Staff");
                          setStaffClose(true);
                        }}
                      >
                        Staff Allocation
                      </button>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default MarketDetailsForm;
